module.exports = __webpack_public_path__ + "img/update3.5_top.e5ccc103.png";